module.exports = __webpack_public_path__ + "media/credit/visa-414cc8b9.png";